import React from 'react';
import { Box, InputField } from 'vindi-ds-components';

function CustomerAddressField() {
  return (
    <Box mb='2rem'>
      <InputField
        placeholder='Ex: Rua de passagem'
        label='Endereço'
        name='address'
      />
    </Box>
  );
}

export default CustomerAddressField;
